<template>
  <div class="Quiz">
    <Questionnaire v-if="!showResults && selectedQuiz"
                   :quiz="selectedQuiz"
                   :currentProgress="currentProgress"
                   :showAnswer="showAnswer"
                   :showTimer="showTimer"
                   :correctAnswer="correctAnswer"
                   :isDisabled="isDisabled"
                   @nextQuiz="goToNextQuiz"
                   @optionClicked="checkAnswer"
                   :isStatus="checkAnswerStatus"
                   :totalIndexes="getTotalQuizCount">
    </Questionnaire>
    <Score v-if="showResults"></Score>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import Questionnaire from './components/Questionnaire';
  import Score from './components/Score';

  export default {
    name: 'Quiz',

    components: {
      Questionnaire,
      Score,
    },

    data() {
      return {
        isNextQuiz: false,
        checkAnswerStatus: false,
        correctAnswer: false,
        showAnswer: false,
        showTimer: true,
        isDisabled: false,
        showResults: false,
        selectedQuiz: null,
      };
    },

    created() {
      if (this.getCurrentQuizIndex + 1 <= this.getTotalQuizCount) {
        this.updateScore({
          quizIndex: this.getCurrentQuizIndex,
          isCorrect: false });
      }
      if (this.getCurrentQuizIndex === this.getTotalQuizCount) {
        this.showResults = true;
      }
      this.selectedQuiz = this.getNextQuiz;
    },

    computed: {
      currentProgress() {
        return this.getCurrentQuizIndex === -1 ? 0 :
          Math.round(((this.getCurrentQuizIndex) * 100) / this.getTotalQuizCount);
      },
      ...mapGetters(['getNextQuiz', 'isCorrectAnswer', 'getScore', 'getCurrentQuizIndex', 'getTotalQuizCount']),
    },

    methods: {
      ...mapMutations(['updateScore']),
      goToNextQuiz() {
        this.checkAnswerStatus = false;
        this.showAnswer = false;
        this.showTimer = true;
        this.isNextQuiz = true;
        this.isDisabled = false;
        if (this.getCurrentQuizIndex + 1 <= this.getTotalQuizCount) {
          this.isNextQuiz = false;
          if (this.correctAnswer) {
            this.updateScore({
              quizIndex: this.getCurrentQuizIndex,
              isCorrect: true });
          } else {
            this.updateScore({
              quizIndex: this.getCurrentQuizIndex,
              isCorrect: false });
          }
          this.selectedQuiz = this.getNextQuiz;
        }
        if (this.getCurrentQuizIndex === this.getTotalQuizCount) {
          this.showResults = true;
          this.isNextQuiz = false;
        }
        this.correctAnswer = false;
      },

      checkAnswer(index) {
        this.checkAnswerStatus = true;
        this.showTimer = false;
        this.showAnswer = true;
        this.isDisabled = true;
        if (this.isCorrectAnswer(index)) {
          this.correctAnswer = true;
        } else {
          this.correctAnswer = false;
        }
        let autoTimer = 3000;
        if (screen.width <= 575) {
          autoTimer = 1500;
        }
        const timer = setTimeout(() => { this.goToNextQuiz(); }, autoTimer);

        const element = document.getElementsByClassName('next');
        element[0].addEventListener('click', () => {
          clearTimeout(timer);
        });
        element[1].addEventListener('click', () => {
          clearTimeout(timer);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .Quiz {
    animation: fadein 2s;
    -moz-animation: fadein 2s; /* Firefox */
    -webkit-animation: fadein 2s; /* Safari and Chrome */
    -o-animation: fadein 2s; /* Opera */
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @-moz-keyframes fadein {
    /* Firefox */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @-webkit-keyframes fadein {
    /* Safari and Chrome */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @-o-keyframes fadein {
    /* Opera */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/Quiz/Quiz.vue